import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';
import Button from 'react-bootstrap/Button';
import ProductSelectIncludeModal from './ProductSelectIncludeModal';
import Select from 'react-select';
import { AllderTable } from 'components/AllderTable';
import { createTableColumns } from 'utils/createTableColumns';
import { marketHandler, productCategoryHandler } from '../../../../redux/handlers';
import { useGlobalTable } from '../../../../hooks/useGlobalTable';
import { ProductDeleteConfirmModal } from './ProductDeleteConfirmModal';
import { ProductSuccessModal } from './ProductSuccessModal';

export default function ProductDataList() {
  const dispatch = useDispatch();
  const { businessSlug } = useParams();
  const [modalproductlistShow, setModalproductlistShow] = useState({
    open: false,
    x: 0,
    y: 0,
    width: 1270,
    height: 680,
    pin: false,
    mode: 'normal',
    modalname: 'edit'
  });

  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [successModalType, setSuccessModalType] = useState('include');
  const [showDeleteConfirmModal, setShowDeleteConfirmModal] = useState(false);
  const [productToDelete, setProductToDelete] = useState(null);

  const [businessPointSettingId, setBusinessPointSettingId] = useState(null);
  const [optionsCategory, setOptionsCategory] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedCategoryId, setSelectedCategoryId] = useState('');

  useEffect(() => {
    const fetchBusinessPointSetting = async () => {
      try {
        const response = await dispatch(marketHandler.getBusinessPointSettingDetail(businessSlug, 'EARN'));
        if (response) {
          setBusinessPointSettingId(response.data.id);
        }
      } catch (error) {
        console.error('Error fetching business point setting:', error);
      }
    };

    fetchBusinessPointSetting();
  }, [dispatch, businessSlug]);

  const fetchCategories = async () => {
    try {
      const response = await dispatch(productCategoryHandler.getAllProductCategories(businessSlug));
      if (response) {
        const options = [
          { value: 'all', label: 'ทั้งหมด' },
          ...response.map(category => ({
            value: category.id,
            label: category.name
          }))
        ];
        setOptionsCategory(options);
      }
    } catch (error) {
      console.error('Error fetching categories:', error);
    }
  };

  useEffect(() => {
    fetchCategories();
  }, [dispatch, businessSlug]);

  const handleCategoryChange = selectedOption => {
    setSelectedCategory(selectedOption);
    const categoryId = selectedOption?.value === 'all' ? '' : selectedOption?.value;
    setSelectedCategoryId(categoryId);
    setFilterParams(prev => ({
      ...prev,
      product_category_id: categoryId
    }));
  };

  const fetchProducts = useCallback(
    params => {
      if (businessPointSettingId) {
        return dispatch(
          marketHandler.getPaginatedBusinessPointProducts(
            businessSlug,
            businessPointSettingId,
            params.page ?? 1,
            params.per_page,
            params.s,
            params.sortBy,
            params.sortOrder,
            params.product_category_id
          )
        );
      }
      return Promise.resolve({ data: [], meta: { total: 0 } });
    },
    [businessSlug, businessPointSettingId, dispatch]
  );

  const {
    data: products,
    loading,
    totalRows,
    paginationModel,
    setPaginationModel,
    handleSort,
    debouncedSearch,
    filterParams,
    setFilterParams,
    refreshData
  } = useGlobalTable({
    fetchData: fetchProducts,
    defaultSort: 'created_at',
    defaultOrder: 'desc',
    defaultPageSize: 10,
    dependencies: [businessPointSettingId, selectedCategoryId]
  });

  const handleDeleteConfirm = async productId => {
    try {
      await dispatch(marketHandler.deleteBusinessPointProduct(productId));
      setSuccessModalType('delete');
      setShowSuccessModal(true);
      refreshData();
    } catch (error) {
      console.error('Error deleting product:', error);
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่');
    }
  };

  const handleDelete = productData => {
    setProductToDelete(productData);
    setShowDeleteConfirmModal(true);
  };

  const columnsd = createTableColumns(
    [
      {
        field: 'product.sku',
        headerName: 'รหัสสินค้า',
        width: 170,
        sortable: false,
        renderCell: ({ row }) => <div style={{ fontWeight: 500, color: '#2DC76D' }}>{row.product?.sku}</div>
      },
      {
        field: 'product.name',
        headerName: 'ชื่อรายการ',
        width: 340,
        sortable: false,
        flex: 1,
        renderCell: ({ row }) => (
          <div className="pimage">
            {row.product?.image_path ? (
              <img
                src={row.product.image_path}
                alt={row.product.name}
                style={{ width: '40px', height: '40px', borderRadius: '50%', marginRight: '10px' }}
                onError={e => {
                  e.target.onerror = null;
                  e.target.src = '/images/img-default.jpeg';
                }}
              />
            ) : (
              <div className="text-center mr-2 mt-1">
                <div
                  style={{
                    width: '40px',
                    height: '40px',
                    borderRadius: '50%',
                    backgroundColor: '#F4F4F4',
                    display: 'inline-flex',
                    justifyContent: 'center',
                    alignItems: 'center'
                  }}
                >
                  <span style={{ color: '#6D788D' }}>{row.product?.name?.slice(0, 1).toUpperCase()}</span>
                </div>
              </div>
            )}
            <div>
              <div style={{ fontWeight: 500 }}>{row.product?.name}</div>
            </div>
          </div>
        )
      },
      {
        field: 'product.productCategory.name',
        headerName: 'หมวดหมู่หลัก',
        width: 180,
        sortable: false,
        renderCell: ({ row }) => <div>{row.product?.productCategory?.name}</div>
      },
      {
        field: 'product.productSubCategory.name',
        headerName: 'หมวดหมู่ย่อย',
        width: 180,
        sortable: false,
        renderCell: ({ row }) => <div>{row.product?.productSubCategory?.name}</div>
      },
      {
        field: 'actions',
        headerName: 'จัดการ',
        width: 120,
        sortable: false,
        type: 'actions'
      }
    ],
    row => (
      <div>
        <Button
          type="button"
          className="btn-delete-st-3"
          onClick={() =>
            handleDelete({
              id: row.id,
              name: row.product?.name
            })
          }
        ></Button>
      </div>
    )
  );

  const handleAddProduct = async selectedProducts => {
    try {
      if (!businessPointSettingId) {
        alert('ไม่พบข้อมูลการตั้งค่า');
        return;
      }

      setModalproductlistShow(prev => ({ ...prev, open: false }));

      setSuccessModalType('include');
      setShowSuccessModal(true);

      setTimeout(() => {
        refreshData();
      }, 500);
    } catch (error) {
      console.error('Error adding products:', error);
      alert('เกิดข้อผิดพลาด กรุณาลองใหม่');
    }
  };

  return (
    <div>
      <div className="card card-st-2">
        <div className="card-body px-0 py-4">
          <div className="d-flex align-items-center px-4 mb-4">
            <div className="tc-7 fs-20 fw-6 me-auto">สินค้าที่ไม่ร่วมรายการ</div>
            <Button
              type="button"
              className="btn btn-st-7"
              onClick={() => setModalproductlistShow(prev => ({ ...prev, open: true }))}
            >
              เพิ่มสินค้า
            </Button>
          </div>

          <div className="d-flex align-items-center px-4 mb-4">
            <div className="me-auto" style={{ flex: '0 0 220px' }}>
              <Select
                value={selectedCategory}
                onChange={handleCategoryChange}
                className="w-100 select-st-1 pd"
                options={optionsCategory}
                placeholder="เลือกหมวดหมู่"
              />
            </div>
            <div className="" style={{ flex: '0 0 220px' }}>
              <input
                type="text"
                className="form-control form-st-4"
                placeholder="ค้นหาสินค้า"
                onChange={e => debouncedSearch(e.target.value)}
              />
            </div>
          </div>

          <AllderTable
            data={products}
            loading={loading}
            columns={columnsd}
            totalRows={totalRows}
            paginationModel={paginationModel}
            setPaginationModel={setPaginationModel}
            handleSort={handleSort}
          />
        </div>
      </div>

      <ProductSelectIncludeModal
        show={modalproductlistShow}
        onHide={() => setModalproductlistShow(prev => ({ ...prev, open: false }))}
        businessSlug={businessSlug}
        businessPointSettingId={businessPointSettingId}
        handleSubmit={handleAddProduct}
        modal={modalproductlistShow}
        setModal={setModalproductlistShow}
      />

      <ProductSuccessModal
        show={showSuccessModal}
        onHide={() => setShowSuccessModal(false)}
        operationType={successModalType}
      />

      <ProductDeleteConfirmModal
        show={showDeleteConfirmModal}
        onHide={() => setShowDeleteConfirmModal(false)}
        onConfirm={() => {
          if (productToDelete) {
            handleDeleteConfirm(productToDelete.id);
          }
          setShowDeleteConfirmModal(false);
        }}
        productData={productToDelete}
      />
    </div>
  );
}

